import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoon, faSun, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faMoon, faSun, faSignOutAlt);

export { FontAwesomeIcon };
